// ----------------------------------------------------------------------
export var MediaChapterType;
(function (MediaChapterType) {
    MediaChapterType[MediaChapterType["music"] = 0] = "music";
    MediaChapterType[MediaChapterType["spokenword"] = 1] = "spokenword";
})(MediaChapterType || (MediaChapterType = {}));
// ----------------------------------------------------------------------
export var MediaType;
(function (MediaType) {
    MediaType[MediaType["audio"] = 0] = "audio";
    MediaType[MediaType["video"] = 1] = "video";
})(MediaType || (MediaType = {}));
